export const environment = {
    production: false,
    URL: 'https://dev-promomultimarca-ws.solucionesfps.pe'
  };
  